;(() => {
  const config = (() => {
    try {
      return JSON.parse(document.getElementById('ThemeConfig')?.textContent || '{}')
    } catch {
      return {}
    }
  })()
  const routes = config.routes || {}
  const strings = config.strings || {}
  const CART_SECTIONS = ['cart-drawer', 'cart-icon-bubble']

  const parse = (html) => new DOMParser().parseFromString(html, 'text/html')

  function toast(message) {
    const node = document.createElement('div')
    node.className = 'toast'
    node.setAttribute('role', 'status')
    node.textContent = message
    document.body.append(node)
    setTimeout(() => node.remove(), 3500)
  }

  async function postJson(url, body) {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'content-type': 'application/json', accept: 'application/json' },
      body: JSON.stringify(body),
    })
    const data = await res.json().catch(() => null)
    if (!res.ok) throw new Error((data && (data.description || data.message)) || strings.error)
    return data
  }

  function renderCount(sections) {
    const html = sections && sections['cart-icon-bubble']
    if (!html) return
    const next = parse(html).querySelector('[data-cart-count]')
    if (!next) return
    for (const count of document.querySelectorAll('[data-cart-count]')) {
      count.textContent = next.textContent
      count.hidden = next.hidden
    }
  }

  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        if (event.target instanceof Element && event.target.closest('[data-drawer-close]'))
          this.close()
      })
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.close()
      })
    }

    open(opener) {
      this.opener = opener || document.activeElement
      this.hidden = false
      document.body.classList.add('is-locked')
      requestAnimationFrame(() => {
        this.classList.add('is-open')
        this.querySelector('.drawer__panel')?.focus()
      })
    }

    close() {
      this.classList.remove('is-open')
      document.body.classList.remove('is-locked')
      setTimeout(() => {
        if (!this.classList.contains('is-open')) this.hidden = true
      }, 300)
      if (this.opener instanceof HTMLElement) this.opener.focus()
    }

    showPending(item) {
      const body = this.querySelector('[data-cart-contents]')
      if (!body || !item || !item.title) return
      let list = body.querySelector('[data-cart-items]')
      if (!list) {
        list = document.createElement('ul')
        list.className = 'cart-items'
        list.setAttribute('data-cart-items', '')
        body.querySelector('.cart-empty')?.setAttribute('hidden', '')
        body.prepend(list)
      }
      this.classList.remove('is-empty')
      const line = document.createElement('li')
      line.className = 'cart-item cart-item--pending'
      const media = document.createElement('span')
      media.className = 'cart-item__media'
      if (item.image) {
        const img = document.createElement('img')
        img.src = item.image
        img.alt = ''
        media.append(img)
      }
      const info = document.createElement('div')
      info.className = 'cart-item__info'
      const title = document.createElement('span')
      title.className = 'cart-item__title'
      title.textContent = item.title
      info.append(title)
      if (item.detail) {
        const detail = document.createElement('span')
        detail.className = 'cart-item__variant'
        detail.textContent = item.detail
        info.append(detail)
      }
      const price = document.createElement('span')
      price.className = 'cart-item__price'
      price.textContent = [item.quantity > 1 ? `${item.quantity} ×` : '', item.price || '']
        .filter(Boolean)
        .join(' ')
      info.append(price)
      line.append(media, info)
      list.prepend(line)
    }

    renderContents(data) {
      const sections = data && data.sections
      renderCount(sections)
      const html = sections && sections['cart-drawer']
      if (!html) return window.location.reload()
      const next = parse(html).querySelector('cart-drawer')
      if (!next) return
      this.classList.toggle('is-empty', next.classList.contains('is-empty'))
      const panel = this.querySelector('.drawer__panel')
      const nextPanel = next.querySelector('.drawer__panel')
      if (panel && nextPanel) panel.innerHTML = nextPanel.innerHTML
      if (!this.classList.contains('is-open')) this.open()
    }
  }
  if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawer)

  const drawer = () => document.querySelector('cart-drawer')

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null
    const opener = target && target.closest('[data-cart-open="drawer"]')
    if (opener && drawer()) {
      event.preventDefault()
      drawer().open(opener)
    }
    const confirmable = target && target.closest('[data-confirm]')
    if (confirmable && !window.confirm(confirmable.dataset.confirm)) event.preventDefault()
  })

  async function changeLine(line, quantity, row) {
    const page = document.querySelector('[data-cart-page]')
    const sections = page ? [page.dataset.sectionId, 'cart-icon-bubble'] : CART_SECTIONS
    row?.classList.add('is-loading')
    try {
      const data = await postJson(`${routes.cartChange || '/cart/change'}.js`, {
        line,
        quantity,
        sections,
      })
      if (page) {
        renderCount(data.sections)
        const next = parse(data.sections[page.dataset.sectionId] || '').querySelector(
          '[data-cart-contents]',
        )
        const current = page.querySelector('[data-cart-contents]')
        if (next && current) current.innerHTML = next.innerHTML
        else window.location.reload()
      } else {
        drawer()?.renderContents(data)
      }
    } catch (error) {
      row?.classList.remove('is-loading')
      toast(error.message || strings.error)
    }
  }

  document.addEventListener('change', (event) => {
    const input = event.target
    if (!(input instanceof HTMLInputElement) || !input.dataset.lineQuantity) return
    const quantity = Math.max(0, Number.parseInt(input.value, 10) || 0)
    changeLine(Number(input.dataset.lineQuantity), quantity, input.closest('.cart-item'))
  })
  document.addEventListener('click', (event) => {
    const button = event.target instanceof Element && event.target.closest('[data-line-remove]')
    if (!button) return
    changeLine(Number(button.dataset.lineRemove), 0, button.closest('.cart-item'))
  })

  document.addEventListener('input', (event) => {
    const input = event.target
    if (!(input instanceof HTMLInputElement) || !input.dataset.lineQuantity) return
    clearTimeout(input.smTimer)
    input.smTimer = setTimeout(
      () => input.dispatchEvent(new Event('change', { bubbles: true })),
      600,
    )
  })

  function formatMoney(cents, format) {
    const value = (cents / 100).toFixed(2)
    const [units, decimals] = value.split('.')
    const group = (sep) => units.replace(/\B(?=(\d{3})+(?!\d))/g, sep)
    return (format || '{{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, (_, kind) => {
      if (kind === 'amount_no_decimals') return group(',')
      if (kind === 'amount_with_comma_separator') return `${group('.')},${decimals}`
      if (kind === 'amount_no_decimals_with_comma_separator') return group('.')
      return `${group(',')}.${decimals}`
    })
  }

  class CartProgress extends HTMLElement {
    connectedCallback() {
      const rate = Number(window.Shopify?.currency?.rate || 1)
      const threshold = Math.round(Number(this.dataset.threshold) * rate)
      const total = Number(this.dataset.total)
      const strings = this.querySelector('[data-progress-strings]')?.content
      const text = this.querySelector('[data-progress-text]')
      const bar = this.querySelector('[data-progress-bar]')
      if (!threshold || !strings || !text || !bar) return
      const remaining = threshold - total
      bar.style.setProperty('--progress', `${Math.min(100, (total / threshold) * 100)}%`)
      text.innerHTML = ''
      if (remaining > 0) {
        const [before, after = ''] = (
          strings.querySelector('[data-remaining]')?.textContent ?? ''
        ).split('[amount]')
        const amount = document.createElement('strong')
        amount.textContent = formatMoney(remaining, this.dataset.moneyFormat)
        text.append(before, amount, after)
      } else {
        text.textContent = strings.querySelector('[data-reached]')?.textContent ?? ''
      }
    }
  }
  if (!customElements.get('cart-progress')) customElements.define('cart-progress', CartProgress)

  class CartTimer extends HTMLElement {
    connectedCallback() {
      const key = 'sm-cart-timer'
      const duration = Number(this.dataset.minutes) * 60_000
      const start = Number(sessionStorage.getItem(key)) || Date.now()
      sessionStorage.setItem(key, String(start))
      const value = this.querySelector('[data-timer-value]')
      const tick = () => {
        const left = start + duration - Date.now()
        if (left <= 0 || !value) {
          this.hidden = true
          clearInterval(this.interval)
          return
        }
        const minutes = Math.floor(left / 60_000)
        const seconds = Math.floor((left % 60_000) / 1000)
        value.textContent = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
        this.hidden = false
      }
      tick()
      this.interval = setInterval(tick, 1000)
    }

    disconnectedCallback() {
      clearInterval(this.interval)
    }
  }
  if (!customElements.get('cart-timer')) customElements.define('cart-timer', CartTimer)

  document.addEventListener('input', (event) => {
    const note = event.target
    if (!(note instanceof HTMLTextAreaElement) || !note.hasAttribute('data-cart-note')) return
    clearTimeout(note.smTimer)
    note.smTimer = setTimeout(() => {
      postJson(`${routes.cartUpdate || '/cart/update'}.js`, { note: note.value }).catch(() => {})
    }, 700)
  })

  class QuantityInput extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        const button = event.target instanceof Element && event.target.closest('button')
        const input = this.querySelector('input')
        if (!button || !input) return
        const min = Number(input.min || 0)
        const value = Number.parseInt(input.value, 10) || 0
        const next = button.name === 'plus' ? value + 1 : Math.max(min, value - 1)
        if (next === value) return
        input.value = String(next)
        input.dispatchEvent(new Event('change', { bubbles: true }))
      })
    }
  }
  if (!customElements.get('quantity-input')) customElements.define('quantity-input', QuantityInput)

  document.addEventListener('submit', async (event) => {
    const form = event.target
    if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-product-form')) return
    if (config.cartType !== 'drawer' || !drawer()) return
    event.preventDefault()
    const button = form.querySelector('[data-add-to-cart]')
    const error = form.querySelector('[data-form-error]')
    button?.setAttribute('aria-busy', 'true')
    if (error) error.hidden = true

    const cart = drawer()
    const scope = form.closest('.product, .card, .hotspot-card, section') || document
    const pick = (selector) => scope.querySelector(selector)
    cart.showPending({
      title: (
        pick('.product__title, .card__title, .hotspot-card__title, h1, h2, h3')?.textContent || ''
      ).trim(),
      image:
        pick('.gallery__slide.is-active img, .gallery__image, .card__media img, img')?.currentSrc ||
        '',
      price: (pick('[data-price] .price__current, .price__current')?.textContent || '').trim(),
      quantity: Number(new FormData(form).get('quantity')) || 1,
    })
    cart.classList.add('is-loading')
    cart.open(button)
    try {
      const body = new FormData(form)
      body.append('sections', CART_SECTIONS.join(','))
      body.append('sections_url', window.location.pathname)
      const res = await fetch(`${routes.cartAdd || '/cart/add'}.js`, {
        method: 'POST',
        headers: { accept: 'application/json', 'x-requested-with': 'XMLHttpRequest' },
        body,
      })
      const data = await res.json().catch(() => null)
      if (!res.ok) throw new Error((data && data.description) || strings.error)
      cart.renderContents(data)
    } catch (err) {
      cart.close()
      if (error) {
        error.textContent = err.message || strings.error
        error.hidden = false
      }
    } finally {
      cart.classList.remove('is-loading')
      button?.removeAttribute('aria-busy')
    }
  })

  class VariantPicker extends HTMLElement {
    connectedCallback() {
      try {
        this.variants = JSON.parse(this.querySelector('[data-variants]')?.textContent || '[]')
      } catch {
        this.variants = []
      }
      this.addEventListener('change', () => this.update())
    }

    selected() {
      const values = []
      for (const input of this.querySelectorAll('input[data-option-position]:checked'))
        values[Number(input.dataset.optionPosition) - 1] = input.value
      for (const fieldset of this.querySelectorAll('fieldset')) {
        const checked = fieldset.querySelector('input:checked')
        const label = fieldset.querySelector('[data-selected-value]')
        if (checked && label) label.textContent = checked.value
      }
      return this.variants.find((variant) => variant.options.every((v, i) => v === values[i]))
    }

    async update() {
      const section = this.closest('[data-product-section]')
      const variant = this.selected()
      const button = section?.querySelector('[data-add-to-cart]')
      const idInput = section?.querySelector('[data-variant-id]')
      if (!variant) {
        if (button) {
          button.disabled = true
          button.textContent = strings.unavailable || ''
        }
        return
      }
      if (idInput) {
        idInput.value = String(variant.id)
        idInput.dispatchEvent(new Event('change', { bubbles: true }))
      }

      const installments = section?.querySelector('[data-installments-variant]')
      if (installments) {
        installments.value = String(variant.id)
        installments.dispatchEvent(new Event('change', { bubbles: true }))
      }
      if (button) {
        button.disabled = !variant.available
        button.textContent = variant.available ? strings.addToCart || '' : strings.soldOut || ''
      }
      const url = new URL(window.location.href)
      url.searchParams.set('variant', String(variant.id))
      window.history.replaceState({}, '', url.toString())
      if (variant.featured_media)
        section
          ?.querySelector('media-gallery')
          ?.show(String(variant.featured_media.id), { smooth: true })

      for (const bundle of section?.querySelectorAll('sm-bundle') ?? [])
        if (typeof bundle.setVariant === 'function') bundle.setVariant(String(variant.id))
      try {
        const res = await fetch(
          `${url.pathname}?variant=${variant.id}&section_id=${this.dataset.section}`,
        )
        const html = parse(await res.text())
        for (const selector of [
          '[data-product-price]',
          '[data-product-badges]',
          '[data-stock-alert]',
        ]) {
          const next = html.querySelector(selector)
          const current = section?.querySelector(selector)
          if (!next || !current) continue
          current.innerHTML = next.innerHTML
        }
      } catch {

      }
    }
  }
  if (!customElements.get('variant-picker')) customElements.define('variant-picker', VariantPicker)

  class MediaGallery extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-gallery-viewport]')
      this.addEventListener('click', (event) => {
        if (!(event.target instanceof Element)) return
        const thumb = event.target.closest('[data-media-target]')
        if (thumb) this.show(thumb.dataset.mediaTarget, { smooth: true })
        const step = event.target.closest('[data-gallery-step]')
        if (step) this.step(Number(step.dataset.galleryStep))
        const thumbsStep = event.target.closest('[data-thumbs-step]')
        const thumbs = this.querySelector('[data-gallery-thumbs]')
        if (thumbsStep && thumbs) {

          const vertical =
            thumbs.scrollHeight > thumbs.clientHeight + 1 &&
            thumbs.scrollWidth <= thumbs.clientWidth + 1
          const step = Number(thumbsStep.dataset.thumbsStep)
          thumbs.scrollBy({
            left: vertical ? 0 : step * thumbs.clientWidth * 0.8,
            top: vertical ? step * thumbs.clientHeight * 0.8 : 0,
            behavior: 'smooth',
          })
        }
      })
      const active = this.querySelector('.gallery__slide[data-active]')
      if (active) this.show(active.dataset.mediaId, { smooth: false })
      if (this.viewport && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            for (const entry of entries)
              if (entry.isIntersecting) this.mark(entry.target.dataset.mediaId)
          },
          { root: this.viewport, threshold: 0.6 },
        )
        for (const slide of this.viewport.children) observer.observe(slide)
      }
    }

    show(mediaId, { smooth }) {
      const slide = this.querySelector(`.gallery__slide[data-media-id="${mediaId}"]`)
      if (!slide || !this.viewport) return

      this.viewport.scrollTo({
        left:
          slide.getBoundingClientRect().left -
          this.viewport.getBoundingClientRect().left +
          this.viewport.scrollLeft,
        behavior: smooth ? 'smooth' : 'auto',
      })
      this.mark(mediaId)

      const thumbs = this.querySelector('[data-gallery-thumbs]')
      const thumb = thumbs?.querySelector(`[data-media-target="${mediaId}"]`)?.parentElement
      if (thumbs && thumb)
        thumbs.scrollTo({
          left:
            thumb.getBoundingClientRect().left -
            thumbs.getBoundingClientRect().left +
            thumbs.scrollLeft -
            (thumbs.clientWidth - thumb.clientWidth) / 2,
          behavior: smooth ? 'smooth' : 'auto',
        })
    }

    step(direction) {
      const slides = [...this.querySelectorAll('.gallery__slide[data-media-id]')]
      if (slides.length < 2) return
      const index = Math.max(
        0,
        slides.findIndex((slide) => slide.dataset.mediaId === this.current),
      )
      const next = slides[(index + direction + slides.length) % slides.length]
      this.show(next.dataset.mediaId, { smooth: true })
    }

    mark(mediaId) {
      this.current = mediaId
      for (const thumb of this.querySelectorAll('[data-media-target]'))
        thumb.setAttribute('aria-current', String(thumb.dataset.mediaTarget === mediaId))
    }
  }
  if (!customElements.get('media-gallery')) customElements.define('media-gallery', MediaGallery)

  class SizeFinder extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog')
      this.querySelector('[data-size-open]')?.addEventListener('click', () =>
        this.dialog?.showModal(),
      )
      this.querySelector('[data-size-close]')?.addEventListener('click', () => this.dialog?.close())

      this.dialog?.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close()
      })
      const form = this.querySelector('[data-size-form]')
      form?.addEventListener('input', () => this.compute())
      form?.addEventListener('submit', (event) => event.preventDefault())

      const guide = this.querySelector('[data-size-guide-form]')
      guide?.addEventListener('input', () => this.computeGuide())
      guide?.addEventListener('change', (event) => {
        if (event.target.matches('[data-size-system]')) this.switchSystem(event.target.value)
      })
      guide?.addEventListener('submit', (event) => event.preventDefault())
      this.querySelector('[data-size-choose]')?.addEventListener('click', () => this.choose())
    }

    switchSystem(system) {
      for (const input of this.querySelectorAll('[data-size-measure]')) {
        const unit = input.parentElement?.querySelector('[data-unit-metric]')
        const factor = input.dataset.metricUnit === 'kg' ? 2.2046 : 1 / 2.54
        if (input.value) {
          const value = Number(input.value)
          input.value = String(
            Math.round((system === 'imperial' ? value * factor : value / factor) * 2) / 2,
          )
        }
        if (unit)
          unit.textContent =
            system === 'imperial' ? unit.dataset.unitImperial : unit.dataset.unitMetric
      }
      this.computeGuide()
    }

    computeGuide() {
      const imperial = this.querySelector('[data-size-system]:checked')?.value === 'imperial'
      const values = {}
      for (const input of this.querySelectorAll('[data-size-measure]')) {
        const value = Number(input.value)
        if (!input.value || !(value > 0)) continue
        const factor = input.dataset.metricUnit === 'kg' ? 2.2046 : 1 / 2.54
        values[input.dataset.sizeMeasure] = imperial ? value / factor : value
      }
      const answer = this.querySelector('[data-size-answer]')
      const rows = [...this.querySelectorAll('[data-size-row]')]
      for (const row of rows) row.removeAttribute('aria-current')
      this.match = null
      if (!answer) return
      if (!Object.keys(values).length) {
        answer.hidden = true
        return
      }
      let best = null
      for (const row of rows) {
        let score = 0
        let compared = 0
        for (const [measure, value] of Object.entries(values)) {
          const cell = row.querySelector(`[data-measure="${measure}"]`)
          const min = Number(cell?.dataset.min)
          const max = Number(cell?.dataset.max)
          compared += 1

          if (!cell?.dataset.min || Number.isNaN(min) || Number.isNaN(max)) {
            score += 1
            continue
          }

          if (value < min) score += (min - value) / Math.max(max - min, 1) + 0.01
          else if (value > max) score += (value - max) / Math.max(max - min, 1)
        }
        if (!compared) continue
        if (!best || score < best.score) best = { row, score }
      }
      const strings = this.querySelector('[data-size-strings]')?.content
      const label = this.querySelector('[data-size-result-label]')
      const size = this.querySelector('[data-size-result-size]')
      if (!best || !label || !size || !strings) {
        answer.hidden = true
        return
      }
      best.row.setAttribute('aria-current', 'true')
      this.match = best.row

      const template = strings.querySelector(best.score === 0 ? '[data-found]' : '[data-close]')
      label.textContent = template?.textContent ?? ''
      size.textContent = best.row.dataset.short || best.row.dataset.value || ''
      answer.hidden = false
    }

    choose() {
      const value = this.match?.dataset.value
      const option = Number(this.dataset.option)
      if (!value || !option) return
      const scope = this.closest('section, .shopify-section') ?? document
      for (const input of scope.querySelectorAll(
        `input[type="radio"][data-option-position="${option}"]`,
      ))
        if (input.value === value && !input.checked) input.click()

      const position = Number(this.match?.dataset.position)
      for (const select of scope.querySelectorAll(`select[data-sm-option="${option - 1}"]`)) {
        const target =
          [...select.options].find((o) => o.value === value) ?? select.options[position]
        if (!target || select.value === target.value) continue
        select.value = target.value
        select.dispatchEvent(new Event('change', { bubbles: true }))
      }
      for (const box of scope.querySelectorAll(`.sm-select[data-sm-option="${option - 1}"]`)) {
        const choices = [...box.querySelectorAll('.sm-select__option')]
        const choice = choices.find((o) => o.dataset.value === value) ?? choices[position]
        if (choice && box.dataset.value !== choice.dataset.value) choice.click()
      }
      this.dialog?.close()
    }

    compute() {
      const value = Number(this.querySelector('[data-size-value]')?.value)
      const unit = this.querySelector('[data-size-unit]:checked')?.value ?? 'cm'
      const column = Number(unit === 'in' ? this.dataset.inColumn : this.dataset.cmColumn) - 1
      const result = this.querySelector('[data-size-result]')
      const strings = this.querySelector('[data-size-strings]')?.content
      if (!result || !strings) return
      const rows = [...this.querySelectorAll('[data-size-row]')]
      for (const row of rows) row.removeAttribute('aria-current')
      if (!value || column < 0) {
        result.hidden = true
        return
      }
      const match = rows.find((row) => {
        const bounds = (row.children[column]?.textContent ?? '')
          .match(/[\d.,]+/g)
          ?.map((n) => Number(n.replace(',', '.')))
        if (!bounds?.length) return false
        const [min, max = min] = bounds
        return value >= min && value <= max
      })
      if (match) match.setAttribute('aria-current', 'true')
      const size = match?.children[0]?.textContent?.trim()
      result.textContent = size
        ? (strings.querySelector('[data-found]')?.textContent ?? '').replace('[size]', size)
        : (strings.querySelector('[data-none]')?.textContent ?? '')
      result.hidden = false
    }
  }
  if (!customElements.get('size-finder')) customElements.define('size-finder', SizeFinder)

  class StickyAtc extends HTMLElement {
    connectedCallback() {
      const section = this.closest('[data-product-section]')
      const button = section?.querySelector('[data-add-to-cart]')
      if (!button || !('IntersectionObserver' in window)) return
      const price = section.querySelector('[data-product-price]')
      const target = this.querySelector('[data-sticky-price]')
      this.querySelector('[data-sticky-add]')?.addEventListener('click', () => {

        if (button.disabled || button.hasAttribute('data-sm-blocked'))
          button.scrollIntoView({ behavior: 'smooth', block: 'center' })
        else button.click()
      })
      this.observer = new IntersectionObserver(([entry]) => {

        const past = !entry.isIntersecting && entry.boundingClientRect.top < 0
        if (past && price && target) target.innerHTML = price.innerHTML
        this.hidden = !past
        document.documentElement.classList.toggle('has-sticky-atc', past)
      })
      this.observer.observe(button)
    }

    disconnectedCallback() {
      this.observer?.disconnect()
      document.documentElement.classList.remove('has-sticky-atc')
    }
  }
  if (!customElements.get('sticky-atc')) customElements.define('sticky-atc', StickyAtc)

  class ScrollTop extends HTMLElement {
    connectedCallback() {
      let ticking = false
      this.onScroll = () => {
        if (ticking) return
        ticking = true
        requestAnimationFrame(() => {
          this.hidden = window.scrollY < window.innerHeight
          ticking = false
        })
      }
      window.addEventListener('scroll', this.onScroll, { passive: true })
      this.onScroll()
      this.querySelector('button')?.addEventListener('click', () =>
        window.scrollTo({ top: 0, behavior: 'smooth' }),
      )
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll)
    }
  }
  if (!customElements.get('scroll-top')) customElements.define('scroll-top', ScrollTop)

  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.children.length || !this.dataset.url) return
      fetch(this.dataset.url)
        .then((res) => res.text())
        .then((text) => {
          const next = parse(text).querySelector('product-recommendations')
          if (next && next.innerHTML.trim()) this.innerHTML = next.innerHTML
        })
        .catch(() => null)
    }
  }
  if (!customElements.get('product-recommendations'))
    customElements.define('product-recommendations', ProductRecommendations)

  document.addEventListener('change', (event) => {
    const field = event.target
    if (!(field instanceof HTMLElement)) return
    const form = field.closest('[data-facets-form]')
    if (form && (field.matches('[data-autosubmit]') || field.matches('input[type="checkbox"]')))
      form.requestSubmit()
  })

  const openDetails = () =>
    document.querySelectorAll(
      'details.dropdown[open], details.facet[open], details.menu-drawer[open]',
    )
  document.addEventListener('click', (event) => {
    for (const details of openDetails())
      if (event.target instanceof Node && !details.contains(event.target))
        details.removeAttribute('open')
  })
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return
    for (const details of openDetails()) {
      details.removeAttribute('open')
      details.querySelector('summary')?.focus()
    }
  })
  document.addEventListener(
    'toggle',
    (event) => {
      const details = event.target
      if (details instanceof HTMLDetailsElement && details.matches('.menu-drawer'))
        document.body.classList.toggle('is-locked', details.open)
    },
    true,
  )

  function parseEnd(text, offset) {
    const match = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/.exec((text || '').trim())
    if (!match) return Number.NaN
    const zone = /^[+-]\d{4}$/.test(offset || '') ? `${offset.slice(0, 3)}:${offset.slice(3)}` : 'Z'
    return Date.parse(`${match[1]}-${match[2]}-${match[3]}T${match[4]}:${match[5]}:00${zone}`)
  }

  class CountdownTimer extends HTMLElement {
    connectedCallback() {

      if (this.hasAttribute('data-midnight')) {
        this.start(this.midnight())
        return
      }
      const end = parseEnd(this.dataset.endsAt, this.dataset.offset)
      if (!Number.isNaN(end)) this.start(end)
    }

    midnight() {
      const end = new Date()
      end.setHours(24, 0, 0, 0)
      return end.getTime()
    }

    start(end) {
      clearInterval(this.timer)
      const output = this.querySelector('[data-countdown]')
      if (Number.isNaN(end) || !output) return
      const pad = (n) => String(n).padStart(2, '0')
      const tick = () => {
        const left = Math.floor((end - Date.now()) / 1000)
        if (left <= 0) {
          clearInterval(this.timer)
          if (this.hasAttribute('data-midnight')) {
            this.start(this.midnight())
            return
          }
          this.hidden = true
          return
        }

        const fr = (document.documentElement.lang || '').startsWith('fr')
        const parts =
          left >= 48 * 3600
            ? [
                [Math.floor(left / 86400), fr ? 'j' : 'd'],
                [Math.floor((left % 86400) / 3600), 'h'],
                [Math.floor((left % 3600) / 60), 'min'],
                ...(this.dataset.seconds === 'true' ? [[left % 60, 's']] : []),
              ]
            : [
                [Math.floor(left / 3600), 'h'],
                [Math.floor((left % 3600) / 60), 'min'],
                [left % 60, 's'],
              ]

        const labels = (this.dataset.labels || '').split(',').map((label) => label.trim())
        if (this.dataset.style === 'boxes') {
          output.replaceChildren(
            ...parts.map(([value, unit], index) => {
              const box = document.createElement('span')
              box.className = 'countdown-box'
              const small = document.createElement('small')
              const label = parts.length === 3 && labels.length === 3 ? labels[index] : ''
              small.textContent = (label || unit).toUpperCase()
              box.append(pad(value), small)
              return box
            }),
          )
        } else {
          output.textContent = parts.map(([value, unit]) => `${pad(value)}${unit}`).join(' ')
        }
        this.hidden = false
      }
      tick()
      this.timer = setInterval(tick, 1000)
    }

    disconnectedCallback() {
      clearInterval(this.timer)
    }
  }
  if (!customElements.get('countdown-timer'))
    customElements.define('countdown-timer', CountdownTimer)

  class ShippingEta extends HTMLElement {
    connectedCallback() {
      const output = this.querySelector('[data-eta]')
      if (!output) return
      const date = new Date()
      let days = Number(this.dataset.days) || 0
      while (days > 0 || date.getDay() === 0 || date.getDay() === 6) {
        date.setDate(date.getDate() + 1)
        if (date.getDay() !== 0 && date.getDay() !== 6) days -= 1
      }
      output.textContent = new Intl.DateTimeFormat(document.documentElement.lang || undefined, {
        weekday: 'short',
        day: 'numeric',
        month: 'short',
      }).format(date)
      this.hidden = false
    }
  }
  if (!customElements.get('shipping-eta')) customElements.define('shipping-eta', ShippingEta)

  const reviewTexts = () => {
    for (const text of document.querySelectorAll('.review-card--ugc .review-card__text')) {
      const more = text.parentElement?.querySelector('[data-review-more]')
      if (more && !text.closest('.is-open'))
        more.hidden = text.scrollHeight <= text.clientHeight + 1
    }
  }
  reviewTexts()
  window.addEventListener('load', reviewTexts)
  document.addEventListener('shopify:section:load', reviewTexts)
  document.addEventListener('click', (event) => {
    const more = event.target instanceof Element && event.target.closest('[data-review-more]')
    if (!more) return
    const card = more.closest('.review-card')
    const open = card.classList.toggle('is-open')
    const [readMore, readLess] = more.children
    readMore.hidden = open
    readLess.hidden = !open
  })

  document.addEventListener('click', (event) => {
    const more = event.target instanceof Element && event.target.closest('[data-reviews-more]')
    if (!more) return
    const section = more.closest('.review-cards__frame')
    const hidden = [...(section?.querySelectorAll('[data-review-extra][hidden]') ?? [])]
    for (const card of hidden.slice(0, 6)) card.hidden = false
    if (hidden.length <= 6) more.closest('.review-cards__more-wrap')?.remove()
  })

  document.addEventListener('click', (event) => {
    const button =
      event.target instanceof Element &&
      event.target.closest('[data-carousel-prev], [data-carousel-next]')
    if (!button) return
    const id = button.dataset.carouselPrev || button.dataset.carouselNext
    const track = id && document.getElementById(id)
    if (!track) return
    const step = (track.firstElementChild?.getBoundingClientRect().width || 240) + 16
    track.scrollBy({ left: button.dataset.carouselPrev ? -step : step, behavior: 'smooth' })
  })

  for (const message of document.querySelectorAll('[data-recurring-every]')) {
    const every = Number(message.dataset.recurringEvery) * 3600000
    const last = parseEnd(`${message.dataset.recurringLast} 23:59`, message.dataset.lastOffset)
    const timer = message.querySelector('countdown-timer')
    if (!(every > 0) || Number.isNaN(last) || !timer) continue
    const key = `sm-countdown:${message.dataset.recurringKey}`
    let first = Number.NaN
    try {
      first = Number(localStorage.getItem(key))
      if (!(first > 0) || first > Date.now()) {
        first = Date.now()
        localStorage.setItem(key, String(first))
      }
    } catch {

      first = Date.now()
    }
    const update = () => {
      const done = Math.floor((Date.now() - first) / every) + 1
      const reset = Math.min(first + done * every, last)
      timer.start(reset)

      if (reset < last)
        setTimeout(update, Math.min(2 ** 31 - 1, Math.max(50, reset - Date.now() + 50)))
    }
    update()
  }

  for (const track of document.querySelectorAll('.announcement-bar__track--rotate')) {
    const messages = [...track.children]
    const visible = (message) => !message.hidden
    let index = Math.max(0, messages.findIndex(visible))
    messages[index]?.classList.add('is-active')
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) continue
    setInterval(() => {
      const next = messages.findIndex((m, i) => i > index && visible(m))
      const target = next === -1 ? messages.findIndex(visible) : next
      if (target === -1 || target === index) return
      messages[index].classList.remove('is-active')
      index = target
      messages[index].classList.add('is-active')
    }, 4500)
  }
})()
